export default __webpack_public_path__ + "static/media/wine.80386f20.png";